import { NavigationExtras } from '@angular/router';

export enum AppNavigatorRoot {
  Dashboard = 'dashboard',
  Mailbox = 'mailbox',
  ReportsNew = 'analytics',
}
export type AppNavigatorRoute = { url: string; extras?: NavigationExtras };
